import { connect } from 'react-redux';
import RuleMasterDashboard from '../components/RuleMasterDashboard';

import {
    ruleMasterQueryInputChange,
    loadRuleMaster,
    initLoadRuleMasterActionStatus,
    selectRuleMaster,
    openAddOrEditRuleMasterModal,
    addOrEditRuleMasterChangeInput,
    resetAddOrEditRuleMasterModal,
    saveRuleMaster,
    initSaveRuleMasterActionStatus,
    deleteRuleMaster,
    initDeleteRuleMasterActionStatus,
    addRuleMasterGridToProps,
} from '../ruleMasterActions';

import { loadCountryCodes } from '../../../home/homeActions';
import { doOperationRecordAction } from '../../../common/operationRcd/OperationRecordActions';

const mapStateToProps = state => {
    return {
        countryCodeDOArray: state.home.countryCodeDOArray,
        ruleMasterQueryFields: state.ruleMaster.ruleMasterQueryFields,
        loadRuleMasterActionStatus: state.ruleMaster.loadRuleMasterActionStatus,
        loadRuleMasterActionResp: state.ruleMaster.loadRuleMasterActionResp,
        selectedRuleMasterArray: state.ruleMaster.selectedRuleMasterArray,
        categoryOptions: state.ruleMaster.categoryOptions,
        fundOptions: state.ruleMaster.fundOptions,
        statusOptions: state.ruleMaster.statusOptions,
        assetClassOptions: state.ruleMaster.assetClassOptions,
        addOrEditRuleMasterModal: state.ruleMaster.addOrEditRuleMasterModal,
        saveRuleMasterActionStatus: state.ruleMaster.saveRuleMasterActionStatus,
        saveRuleMasterActionResp: state.ruleMaster.saveRuleMasterActionResp,
        deleteRuleMasterActionStatus: state.ruleMaster.deleteRuleMasterActionStatus,
        deleteRuleMasterActionResp: state.ruleMaster.deleteRuleMasterActionResp,
        ruleMasterGrid: state.ruleMaster.ruleMasterGrid,
        operationRecord: state.operationRecord,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        loadCountryCodes: () => dispatch(loadCountryCodes()),
        ruleMasterQueryInputChange: input => dispatch(ruleMasterQueryInputChange(input)),
        loadRuleMaster: () => dispatch(loadRuleMaster()),
        initLoadRuleMasterActionStatus: () => dispatch(initLoadRuleMasterActionStatus()),
        selectRuleMaster: array => dispatch(selectRuleMaster(array)),
        openAddOrEditRuleMasterModal: (mode, data) => dispatch(openAddOrEditRuleMasterModal(mode, data)),
        addOrEditRuleMasterChangeInput: input => dispatch(addOrEditRuleMasterChangeInput(input)),
        resetAddOrEditRuleMasterModal: () => dispatch(resetAddOrEditRuleMasterModal()),
        saveRuleMaster: bean => dispatch(saveRuleMaster(bean)),
        initSaveRuleMasterActionStatus: () => dispatch(initSaveRuleMasterActionStatus()),
        deleteRuleMaster: rows => dispatch(deleteRuleMaster(rows)),
        initDeleteRuleMasterActionStatus: () => dispatch(initDeleteRuleMasterActionStatus()),
        addRuleMasterGridToProps: grid => dispatch(addRuleMasterGridToProps(grid)),
        doOperationRecordAction: params => dispatch(doOperationRecordAction(params)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RuleMasterDashboard);
